<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="FMEP"><span class="ePub-BI">We once lived rooted</span></p>
<p class="FMEP"><span class="ePub-BI">Like the ancient olive trees.</span></p>
<p class="FMEP"><span class="ePub-BI">Now we’re birds</span></p>
<p class="FMEP"><span class="ePub-BI">Nesting on songs</span></p>
<p class="FMEP"><span class="ePub-BI">About homes we miss.</span></p>
<p class="FMEP"><span class="ePub-BI">Storms and distances</span></p>
<p class="FMEP"><span class="ePub-BI">Decide our address.</span></p>
<p class="FMEPC"><span class="ePub-B">—<a href="http://us.macmillan.com/author/ibtisambarakat?utm_source=ebook&amp;utm_medium=adcard&amp;utm_term=ebookreaders&amp;utm_content=ibtisambarakat_authorpage_macdotcom&amp;utm_campaign=9780374302535" target="_blank">Ibtisam Barakat</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?36043640